const tipo = {
  celular: /\(\d{2}\) \d{5}-\d{4}/,
  cep: /\d{5}-\d{3}/,
  cpf: /\.|-/g,
  cnpj: /\.|-|\//g,
  telefone: /\(\d{2}\) \d{4}-\d{4}/
}

const validar = (valor, tipo) => {
  return tipo.test(valor)
}

const pegaNumeroEm = (valor, index) => parseInt(valor.charAt(index))

const cpfCombinacao = (digitos) => {
  let sum = null

  for (let i = 0; i < 9; ++i) {
    sum += digitos.toString().charAt(i) * (10 - i)
  }

  const ultimoDigito = sum % 11
  const valor = (ultimoDigito < 2) ? 0 : 11 - ultimoDigito

  return valor
}

const cpfValidacao = (combinacao) => {
  let sum = null

  for (let i = 0; i < 10; ++i) {
    sum += combinacao.toString().charAt(i) * (11 - i)
  }

  const ultimoDigito = sum % 11
  const valor = (ultimoDigito < 2) ? 0 : 11 - ultimoDigito

  return valor
}

const validarCPF = (valor, tipo) => {
  if (!tipo.test(valor)) return false

  const cpf = valor.toString().replace(tipo, '')
  const numeros = cpf.substring(0, 9)
  const verificador = cpf.substring(9, 11)

  // verificando se são digitos iguais
  for (let i = 0; i < 10; i++) {
    if (`${numeros}${verificador}` === Array(12).join(i)) {
      return false
    }
  }

  const combinacao = cpfCombinacao(numeros)
  const validacao = cpfValidacao(`${numeros}${combinacao}`)

  return verificador.toString() === (combinacao.toString() + validacao.toString())
}

const validarCNPJ = (valor, tipo) => {
  if (!tipo.test(valor)) return false

  const valida = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  let dig1, dig2

  const cnpj = valor.toString().replace(tipo, '')
  let digito = pegaNumeroEm(cnpj, 12) + pegaNumeroEm(cnpj, 13)

  for (let i = 0; i < valida.length; i++) {
    dig1 += i > 0 ? (pegaNumeroEm(cnpj, i - 1) * valida[i]) : 0
    dig2 += pegaNumeroEm(cnpj, i) * valida[i]
  }

  dig1 = (((dig1 % 11) < 2) ? 0 : (11 - (dig1 % 11)))
  dig2 = (((dig2 % 11) < 2) ? 0 : (11 - (dig2 % 11)))

  return ((dig1 * 10) + dig2) === digito
}

export default {
  cep: (valor) => validar(valor, tipo.cep),
  cpf: (valor) => validarCPF(valor, tipo.cpf),
  cnpj: (valor) => validarCNPJ(valor, tipo.cnpj),
  celular: (valor) => validar(valor, tipo.celular),
  telefone: (valor) => validar(valor, tipo.telefone)
}



// WEBPACK FOOTER //
// ./src/services/Validacao.js